<app-page>
    <app-loadable-content [loadingController]="loadingController" (onRetry)="loadMenuAvailability()">
        <app-title>{{ getLocationName() }}</app-title>
        <div align="center"><app-subtitle>{{ 'menu_availability' | translate }}</app-subtitle></div>
        <div align="center">
            <mat-button-toggle-group (change)="onMenuAvailabilityTypeChange($event)">
                <mat-button-toggle value="menu_entries" checked>{{ 'menu_items' | translate }}</mat-button-toggle>
                <mat-button-toggle value="menu_options">{{ 'menu_options' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <br>
        <table align="center" appFieldContainer>
            <tr>
                <td>
                    <mat-form-field appField>
                        <mat-label>{{ 'search' | translate }}</mat-label>
                        <input matInput type="text" [formControl]="searchFormControl">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </td>
            </tr>
        </table>
        <table width="100%">
            <tr *ngIf="showMenuEntries">
                <td>
                    <app-data-table
                        [data]="menuEntries"
                        [columns]="menuEntriesColumns">
                    </app-data-table>
                </td>
            </tr>
            <tr *ngIf="showItems">
                <td>
                    <app-data-table
                        [data]="items"
                        [columns]="itemsColumns">
                    </app-data-table>
                </td>
            </tr>
            <tr>
                <td align="center">
                    <app-action text="{{ 'update' | translate }}" (onAsyncExecute)="updateMenuAvailability($event)"></app-action>
                </td>
            </tr>
        </table>
    </app-loadable-content>
</app-page>